import { render, staticRenderFns } from "./TeachingForm.vue?vue&type=template&id=be19021e&"
import script from "./TeachingForm.vue?vue&type=script&lang=js&"
export * from "./TeachingForm.vue?vue&type=script&lang=js&"
import style0 from "./TeachingForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports